import React from 'react';
import Navigation from '../../services/Navigation';
import FullScreenVerticalCenterContent from '../../styledhtml/FullScreenVerticalCenterContent';
import LoadingIndicator from '../../components/LoadingIndicator';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

export default class LandingPage extends LogictryComponent {
  render() {
    setTimeout(() => Navigation.push(Navigation.login), 100);
    return <FullScreenVerticalCenterContent><LoadingIndicator /></FullScreenVerticalCenterContent>;
  }
}
